"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isSessionStorageSupported = void 0;
var TEST = 'test';
// eslint-disable-next-line import/no-mutable-exports -- needed
var isSessionStorageSupported = function() {
    try {
        sessionStorage.setItem(TEST, TEST);
        sessionStorage.removeItem(TEST);
        exports.isSessionStorageSupported = isSessionStorageSupported = function() {
            return true;
        };
        return isSessionStorageSupported();
    } catch (error) {
        exports.isSessionStorageSupported = isSessionStorageSupported = function() {
            return false;
        };
        return isSessionStorageSupported();
    }
};
exports.isSessionStorageSupported = isSessionStorageSupported; //# sourceMappingURL=isSessionStorageSupported.js.map
